module.exports = __webpack_public_path__ + "static/media/challenge-default-image.87b2c173.png";